import React from "react";
import { Alert, Box, Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export type ArmeniaAct = {
  id: number;
  tn_id: string;
  status?: string;
  version?: number;
  act_date?: string;
  payout?: number;
  total_revenue?: number;
  payout_hold?: number;
  payout_privl?: number;
  total_revenue_hold?: number;
  total_revenue_privl?: number;
  metadata?: any;
};

type Props = {
  act?: ArmeniaAct | null;
  isAdmin: boolean;
};

const ArmeniaActActions = ({ act, isAdmin }: Props) => {
  const { t } = useTranslation();

  if (!act?.id) {
    return (
      <Alert severity="info" sx={{ mb: 2 }}>
        {t("armeniaAct.actions.notFormed")}
      </Alert>
    );
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Stack spacing={1}>
        <Typography variant="body2">
          {t("armeniaAct.actions.formed")}
        </Typography>

        <Stack direction="row" spacing={1}>
          <Button
            variant="contained"
            href={`/acts/${act.id}/print/act`}
            target="_blank"
          >
            {t("armeniaAct.actions.download")}
          </Button>

          {!isAdmin && (
            <>
              <Button variant="outlined" color="warning">
                {t("armeniaAct.actions.dispute")}
              </Button>

              <Button variant="outlined" color="success">
                {t("armeniaAct.actions.sign")}
              </Button>
            </>
          )}
        </Stack>
      </Stack>
    </Box>
  );
};

export default ArmeniaActActions;
